package app.nestbridge.feature.children.usecase

import app.nestbridge.feature.children.model.Child
import app.nestbridge.feature.children.service.ChildService
import me.tatarka.inject.annotations.Inject

@Inject
class GetChildUseCase(
    private val childService: ChildService,
) {
    suspend operator fun invoke(id: String): Child? = childService.get(id)
}
